angular.module('impactx.productcoding').controller('ProductGroupDeleteDialogCtrl', ['$scope', '$mdDialog', 'TranslationService',
    'themeFactory', 'dataGen', 'ToastService',
    ProductGroupDeleteDialogCtrl]);

function ProductGroupDeleteDialogCtrl($scope, $mdDialog, TranslationService, themeFactory, dataGen, ToastService)
{
    $scope.abortLabel = TranslationService.get("abort");
    $scope.deleteLabel = TranslationService.get("delete");

    $scope.theme = themeFactory.getTheme();
    var self = this;
    self.requestInProgress = false;

    self.cancel = function() {
        $mdDialog.cancel();
    };

    self.delete = function() {
        self.requestInProgress = true;
        dataGen.postAsForm($scope, {id: self.prgId, catId: self.catId, vcatId: self.vcatId, deleteSetting: self.deleteSetting}, "/productgroup/delete").then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            $mdDialog.hide();
        }).finally(function () {
            self.requestInProgress = false;
        });
    };
}